import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { SI_PORTAL_BASE_PATH, SI_PORTAL_TABS, abaEmBreve, podeAcessarAbaSiPortal } from '../siPortal.definitions';
import { useAuth } from '@/contexts/AuthContext';
import type { SiPortalTabId } from '../siPortal.types';

interface SiPortalTabGuardProps {
  tabId: SiPortalTabId;
  children: ReactNode;
}

/** Quem digita o caminho de uma aba que não pode ver volta pro portal (mesma regra do DP). */
export function SiPortalTabGuard({ tabId, children }: SiPortalTabGuardProps) {
  const { userHasRole } = useAuth();
  const tab = SI_PORTAL_TABS.find((item) => item.id === tabId);
  const contexto = { hasRole: userHasRole };
  if (!tab || !podeAcessarAbaSiPortal(tab, contexto) || abaEmBreve(tab, contexto)) {
    return <Navigate to={SI_PORTAL_BASE_PATH} replace />;
  }
  return <>{children}</>;
}
